// extracted by css-extract-rspack-plugin
export default {"tabButton":"DashboardTabs-module__tabButton___jlR5y","createTabButton":"DashboardTabs-module__createTabButton____Dn1O"};